import React from "react";
import { solutions } from "@/content/site";
import { PageHero, Section, CtaBand, FeatureCard, CardGrid } from "@/components/NovaKit";

export default function SolutionsAccountants() {
  const s = solutions.accountants;
  return (
    <div data-testid="solutions-accountants-page">
      <PageHero eyebrow="Solutions / For Accountants & Other Professional Services" heading="Workflow, coordination, and growth tools for document-intensive practices" highlight="document-intensive practices" intro={s.intro} index="05.2" />
      <Section eyebrow="Why this matters" heading="Firms rarely struggle because expertise is weak" highlight="expertise is weak" indexLabel="05.2.0" bg="panel">
        <p className="text-base md:text-xl leading-[1.6] text-[#0A0E1A]/85 max-w-4xl border-l-4 border-[#4F46E5] pl-6">
          {s.why}
        </p>
      </Section>
      <Section eyebrow="Recommended sequence" heading="How the four families apply to professional practices" highlight="four families" indexLabel="05.2.1">
        <CardGrid cols={2}>
          {s.blocks.map(([title, body], i) => (
            <FeatureCard key={title} index={`STEP · 0${i + 1}`} title={title} body={body} featured={i === 0} />
          ))}
        </CardGrid>
      </Section>
      <Section eyebrow="Outcomes" heading="What professional teams walk away with" highlight="walk away with" indexLabel="05.2.2" bg="panel">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {s.outcomes.map((o, i) => (
            <div key={o} className="grad-border grad-border-on card-hover bg-white rounded-[20px] p-6 md:p-8 flex items-start gap-4">
              <span className="mono text-[11px] tracking-[0.22em] uppercase grad-text font-bold mt-1">{String(i + 1).padStart(2, "0")}</span>
              <p className="text-base leading-relaxed text-[#0A0E1A]/85 flex-1">{o}</p>
            </div>
          ))}
        </div>
      </Section>
      <Section indexLabel="05.2.3" eyebrow="Note" heading="Why this works beyond accountants" highlight="beyond accountants">
        <p className="text-base md:text-lg leading-relaxed text-[#0A0E1A]/80 max-w-4xl border-l-4 border-[#4F46E5] pl-6 italic">
          {s.support}
        </p>
      </Section>
      <CtaBand heading="Let's strengthen your practice operating model." ctas={[s.cta, { label: "Become a Partner", to: "/contact?form=partner", variant: "secondary" }]} />
    </div>
  );
}
